module.exports = "vec2 rotate2D(vec2 _st, float _angle){\n        _st -= 0.5;\n        _st =  mat2(cos(_angle),-sin(_angle), sin(_angle),cos(_angle)) * _st;\n        _st += 0.5;\n  return _st;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/chunks/rotate.raw.xml
// module id = joTG
// module chunks = 1